'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';

exports.FOCUS_DISABLED = FOCUS_DISABLED;
exports.FOCUS_GROUP = FOCUS_GROUP;